import { useEffect } from 'react';

import { useDownloadOobeeSDK } from './useDownloadOobeeSDK';
import { useOnOobeeError } from './useOnOobeeError';
import { useRequestOobeePacket } from './useRequestOobeePacket';

export const useOobeeIntegration = ({
    sdk,
    enable,
    mobileClientURL,
    oobeeURL,
    license,
    identifierType,
    disableStoreAutoLaunch,
    transactionID,
    userId,
    useTransparentPopup,
    onConnect,
    setShowOverlay,
    receivePacket
}) => {
    const downloadOobeeSDK = useDownloadOobeeSDK({ mobileClientURL });
    const onError = useOnOobeeError({ sdk, transactionID, setShowOverlay, useTransparentPopup });
    const requestOobeePacket = useRequestOobeePacket({
        sdk,
        license,
        transactionID,
        userId,
        identifierType,
        setShowOverlay,
        useTransparentPopup,
        disableStoreAutoLaunch,
        oobeeURL,
        onError,
        receivePacket
    });

    useEffect(() => {
        if (!enable || !sdk) {
            return;
        }

        onConnect();
    }, [sdk, enable, oobeeURL, onConnect]);

    return { requestOobeePacket, downloadOobeeSDK };
};
